import Employee from "@/employee/Employee"
import ValueMod from "@/effects/ValueMod"
import { Personality } from "@/employee/Personality"

export class SlutPersonality extends Personality {
    id: string = 'slut'
    affix: string = 'suffix'

    description(): string {
      return `Sluts like having sex often, and won't be satisfied unless they do.`
    }

    get constantMods(): { [key: string]: [ValueMod] } {
      return {
        "sexReqLust": [new ValueMod(0.5, 'mul')],
        "sexMood": [new ValueMod(1, 'mul')],
        "sexMoodDuration": [new ValueMod(0.75, 'mul')],
        "sexLustLoss": [new ValueMod(0.5, 'mul')],
        "masturbationLustLoss": [new ValueMod(0.75, 'mul')],
      }
    }

    onUpdate(dt: number, employee: Employee) {
      employee.lustDelta.valueMods['slut'] = new ValueMod(2, 'mul')
    }

    onSex(employee: Employee) {
    }

    onCuddle(employee: Employee) {
    }
}
